import { Flex, ButtonGroup, Button, Text, Link, Image } from '@chakra-ui/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';
import { RingBackgroundPage } from '@/templates/RingBackgroundPage';
import pwhale  from '@/assets/images/pwhale.png';
const PageNotFound: React.FC = () => {
  const { t } = useTranslation();
  return (
    <RingBackgroundPage>
      <Flex align="center" direction="column" justify="center">
        <Text color="blue" fontSize="6xl">
          404
        </Text>
        <Text color="blue" fontSize="xl">
          {t('this_page_not_exist')}
        </Text>
        <Image m={4} src={pwhale} />
        <ButtonGroup mt={8} spacing="6" variant="outline">
          <Link as={RouterLink} to="/home" variant="no-decoration">
            <Button colorScheme="blue">{t('homepage')}</Button>
          </Link>
          <Link as={RouterLink} to="/console" variant="no-decoration">
            <Button colorScheme="blue" variant="solid">
              {t('developer_console')}
            </Button>
          </Link>
        </ButtonGroup>
      </Flex>
    </RingBackgroundPage>
  );
};

export default PageNotFound;
